import { createHash } from 'crypto'

export function getValueHash(value: unknown) {
  if (typeof value !== 'string') {
    value = JSON.stringify(value)
  }
  return createHash('md5')
    .update(value as string)
    .digest('hex')
}
